import { useGetQuizDefinition } from '@/hooks/useGetQuizDefinition.util.ts';
import { useGetQuizDetails } from '@/hooks/useGetQuizDetails.ts';
import { useGetQuizIdentifiers } from '@/hooks/useGetQuizIdentifiers.ts';
import { useGetUserQuizState } from '@/hooks/useGetUserQuizState.ts';
import { useGetUserQuizzes } from '@/hooks/useGetUserQuizzes.ts';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import { ProcessTimer } from '@/views/process/components/ProcessTimer.comp.tsx';
import Intro from '@/views/process/components/quizInialized/intro/Intro.tsx';
import Questions from '@/views/process/components/quizInialized/Questions.tsx';
import QuestionProgress from '@/views/process/pages/quizInitializedPage/QuestionProgress.tsx';
import React, { useState } from 'react';

const QuizInitializedPage: React.FC = () => {
  const [visibleIntro, setVisibleIntro] = useState(true);
  const { isGettingQuizIdentifier, quizIdentifier, quizIdentifierError } = useGetQuizIdentifiers();

  const { isGettingUserQuizzes, userQuizzes, userQuizzesError } = useGetUserQuizzes({
    quizId: quizIdentifier?.quizId,
  });
  const userQuizId = userQuizzes?.[0]?.userQuizId;

  const { quizDefinition } = useGetQuizDefinition(quizIdentifier?.quizId);

  const { isGettingQuizState, quizState, quizStateError } = useGetUserQuizState({
    userQuizId,
  });

  const { isGettingQuizDetails, quizDetails, quizDetailsError } = useGetQuizDetails({
    userQuizId,
  });

  const { user } = useUserContext();
  const userId = user?.userId;

  if (!userId) {
    return null;
  }

  const handleFinishIntro = () => {
    setVisibleIntro(false);
  };

  const isLoading =
    isGettingUserQuizzes || isGettingQuizState || isGettingQuizIdentifier || isGettingQuizDetails;
  const hasErrors = userQuizzesError || quizStateError || quizIdentifierError || quizDetailsError;

  const currentQuestionId =
    quizState?.currentQuestionIndex === null || quizState?.currentQuestionIndex === undefined
      ? null
      : quizState?.currentQuestionIndex + 1;

  const isFirstQuestion = currentQuestionId && currentQuestionId === 1;
  const noOfQuestions = quizState?.noOfQuestions;
  return (
    <ProcessTimer
      hasQuestionIndex={currentQuestionId !== null}
      quizDueTime={quizDetails?.userQuizTimeState.quizDueTime}
      quizTimeToComplete={quizDefinition?.timeToCompleteInMinutes}
      userQuizId={userQuizId}
    >
      {isFirstQuestion && visibleIntro ? (
        <div className="mt-3">
          <Intro onFinishIntro={handleFinishIntro} />
        </div>
      ) : (
        <div className="mt-3">
          <QuestionProgress currentQuestionId={currentQuestionId} noOfQuestions={noOfQuestions} />
          <Questions
            currentQuestionId={currentQuestionId}
            errors={hasErrors}
            isLoading={isLoading}
            quizDetails={quizDetails}
            userQuizId={userQuizId}
          />
        </div>
      )}
    </ProcessTimer>
  );
};

export default QuizInitializedPage;
